module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-76x76-ef2676cc9b7eab583fbd633307ddcfca.png";